<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  export default {

  }
</script>

<style lang="stylus">
#app
  text-align: center
  width 100%
  height 100%

</style>
